import Navbar from "../components/Navbar"
import Profile from "../components/Profile"

const Me = () => {
    return (
        <div className="app">
            <Navbar />
            <Profile />
        </div>
    );
};

export default Me; 